<template>
  <div class="allOrder">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="反馈问题" name="first">
        <div class="feedback">
          <p class="til">反馈问题<span>（必选）</span></p>
          <div class="questionback">
            <div v-for="(item, index) in feedbackType" :key="index" :class="item.id == uid ? 'btn_backs' : 'btn_back'"
              @click="getfkid(item)">
              {{ item.name }}
            </div>
          </div>
          <p class="til tils">我要反馈<span>（必填）</span></p>
          <div class="btn_feedback">
            <el-input v-model="formData.content" type="textarea" :rows="4" :disabled="uid == null"
              placeholder="请输入您要反馈的内容" maxlength="200" show-word-limit />
          </div>
          <div class="btm_flex">
            <div class="pic">
              <el-upload ref="backgroundImage" :action="imgAction()" list-type="picture-card" name="upload"
                :headers="DomainAuthorization" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :limit="3">
                <i slot="default" class="el-icon-plus" />
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                </div>
              </el-upload>
              <div class="pic_num">
                <span>{{ num }}</span>/3
              </div>
              <div class="pic_bot">点击上传图片（最多可上传3张，每张小于2M）</div>
            </div>
            <div class="btn_sub" @click="saveFeedback">确认提交</div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="反馈记录" name="second">
        <div class="my-list">
          <div v-if="feedbackListByUser.length > 0">
            <div class="my-list-item" v-for="(item, index) of feedbackListByUser" :key="index"
              @click="clickFeedback(item)">
              <div class="tag-row1"></div>
              <div class="tag-row2"></div>
              <div class="item-con">
                <div class="content">
                  <div class="item-title">{{ item.content }}</div>
                  <div class="content-img" v-if="item.pictureList.length > 0">
                    <el-image :src="val" alt="" v-for="(val, idx) in item.pictureList" :key="idx"
                      :preview-src-list="item.pictureList"></el-image>
                  </div>
                  <div class="cat">
                    <div>{{ item.type }}</div>
                    <div class="time">提交时间：{{ item.createTime }}</div>
                  </div>
                </div>
                <div class="reply-content" v-if="item.feedbackReplyVO">
                  <div class="row">回复内容</div>
                  <div style="margin-bottom: 10px;" class="row row-info">{{ item.feedbackReplyVO.content }}</div>
                  <div class="row">
                    <el-image :src="val" alt="" v-for="(val, idx) in item.feedbackReplyVO.pictureList" :key="idx"
                      :preview-src-list="item.feedbackReplyVO.pictureList"></el-image>
                  </div>
                  <div class="row-info">回复时间：{{ item.feedbackReplyVO.createTime }}</div>
                </div>
              </div>
            </div>
          </div>
          <el-empty class="no-data ml100" description="暂无数据~" v-else></el-empty>
        </div>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>
<script>
import { getInfo, getDomainToken } from '@/api/cookies'
import { BaseClient } from "@/api/baseCon";
const baseClient = new BaseClient();
export default {
  data() {
    return {
      activeName: "first",
      feedbackType: [
        { id: 1, name: '改进建议' },
        { id: 2, name: '授课师资问题' },
        { id: 3, name: '在线考试问题' },
        { id: 4, name: '辅导资料问题' },
        { id: 5, name: '班主任管理' },
        { id: 6, name: '其他' }
      ],
      textarea: '',
      num: 0,
      DomainAuthorization: {
        DomainAuthorization: getDomainToken()
      },
      uid: 1,
      imgs: [],
      formData: {
        name: '改进建议',
        content: null,
        img: '',
        userId: null
      },
      userInfo: {},
      feedbackListByUser: []
    }
  },

  async created() {
    this.userInfo = await getInfo()
    this.formData.userId = this.userInfo.userId
    this.getFeedbackList();
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    handleClick() {
      if (this.activeName === "first") {
        // this.getList();
      } else if (this.activeName === "second") {
        this.getFeedbackList();
      }
    },
    handleAvatarSuccess(res, i, fileList) {
      this.num = fileList.length
      if (fileList) {
        this.fileList = []
        this.imgs = []
        for (const items of fileList) {
          this.imgs.push(items.response.data)
        }
        this.formData.img = this.imgs.join(',')
      }
    },
    //获取反馈列表
    async getFeedbackList() {
      await baseClient.getFeedbackListByUser().then((res) => {
        this.feedbackListByUser = res.data;
      });
    },
    async saveFeedback() {
      if (this.formData.content) {
        await baseClient.saveFeedback(
          this.formData.content,
          this.uid.toString(),
          this.imgs,
        ).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: '反馈成功',
              type: 'success'
            })
            this.formData.content = ''
            this.formData.img = ''
            this.$refs.backgroundImage.clearFiles()
            this.num = 0
          } else {
            this.$message.error('反馈失败')
          }
        })
      } else {
        this.$message({
          message: '请将信息填写完整',
          type: 'warning'
        })
      }
    },
    getfkid(item) {
      this.uid = item.id
      this.formData.name = item.name
    }
  }
}
</script>
<style lang="less" scoped>
.allOrder {
  width: 100%;
  background-color: #ffffff;
  position: relative;

  /deep/ .el-tabs__nav-wrap {
    padding: 8px 32px 0px;

    .el-tabs__nav {
      // padding-bottom: 8px;
      margin-bottom: 6px;
    }

    .el-tabs__active-bar {
      width: 24px !important;
      height: 2px;
      background: #ff5d51;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      padding-bottom: 3px;
      bottom: -5px;
      left: 3px;
    }

    .el-tabs__item {
      font-size: 16px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999 !important;
    }

    .is-active {
      color: #333333 !important;
    }
  }

  /deep/.el-tabs__content {
    padding: 10px 38px 0;
    width: 100%;

    .el-tab-pane {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }

  .feedback {
    width: 100%;
    height: 520px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin: 0 auto;

    .til {
      font-size: 16px;
      font-family: Microsoft YaHei-Regular;
      font-weight: 400;
      color: #333333;
      line-height: 16px;
      padding-top: 24px;
      margin-left: 40px;

      span {
        font-size: 14px;
        color: #999999;
      }
    }

    .tils {
      margin-top: 40px;
    }

    .questionback {
      display: flex;
      justify-content: start;
      margin-top: 24px;
      margin-left: 40px;

      .btn_back {
        width: 128px;
        height: 40px;
        background: #eeeeee;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #666666;
        margin-right: 20px;
        cursor: pointer;
      }

      .btn_backs {
        width: 128px;
        height: 40px;
        background: #ffe6e4;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #ff5e51;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #ff5e51;
        margin-right: 20px;
        cursor: pointer;
      }
    }

    .btn_feedback {
      width: calc(100% - 80px);
      margin: 0 auto;
      margin-top: 24px;

      border-radius: 8px 8px 8px 8px;
    }
  }

  ::v-deep .el-textarea__inner {
    background: #f7f7f7 !important;
  }

  .btm_flex {
    display: flex;
    justify-content: space-between;

    ::v-deep .pic {
      display: flex;
      justify-content: flex-start;
      margin-top: 12px;
      margin-left: 40px;

      .el-upload--picture-card {
        width: 60px;
        height: 60px;
        background: #f7f7f7;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #dddddd;
        line-height: 60px;
      }

      .el-upload-list--picture-card {
        width: 60px;
        height: 60px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        line-height: 60px;
      }

      .el-upload-list__item {
        width: 60px;
        height: 60px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        line-height: 60px;
      }

      .pic_num {
        width: 23px;
        height: 14px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
        margin-top: 46px;

        span {
          color: #ff5e51;
        }
      }

      .pic_bot {
        width: 297px;
        height: 14px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #999999;
        margin-top: 46px;
        line-height: 14px;
      }
    }

    .btn_sub {
      width: 120px;
      height: 40px;
      background: #ff5e51;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      font-size: 16px;
      font-family: Microsoft YaHei-Regular;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      margin-top: 22px;
      margin-right: 40px;
      cursor: pointer;
    }
  }

  .mantil {
    height: 104px;
    line-height: 104px;
    font-size: 24px;
    font-family: Microsoft YaHei-Bold;
    font-weight: bold;
    color: #333333;
    text-align: left;
    background-color: #f5f7f9;
  }

  .my-list {
    margin-top: 20px;
    padding-bottom: 15px;

    .my-list-item {
      position: relative;
      width: 1090px;

      padding: 0 20px 20px 20px;
      margin: auto;
      border-left: 1px dashed #007efb;

      .tag-row1 {
        position: absolute;
        top: 0;
        left: -9px;
        width: 16px;
        height: 16px;
        background-color: #007efb;
        border-radius: 50%;
      }

      .tag-row2 {
        position: absolute;
        top: 4px;
        left: -5px;
        width: 8px;
        height: 8px;
        background-color: #fff;
        border-radius: 50%;
      }

      .item-con {
        .reply-content {
          margin-top: 24px;
          font-size: 14px;
          padding: 20px 24px;
          font-size: 14px;
          background-color: #f7f6f9;
          border-radius: 4px;

          .row {
            display: flex;
          }

          .row-info {
            margin: 20px 0 0px 0;
            color: #777777;
          }

          .el-image {
            width: 100px;
            height: 100px;
            margin-right: 20px;
            border-radius: 8px;
          }
        }

        .content {
          .cat {
            margin: 20px 0 0px 0;
            width: 100%;
            color: #999999;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .time {
              color: #aaaaaa;
              line-height: 14px;
              font-size: 14px;
            }
          }

          .content-img {
            .el-image {
              width: 100px;
              height: 100px;
              margin-right: 20px;
              border-radius: 8px;
            }
          }

          .item-title {
            color: #333333;
            margin-bottom: 16px;
            font-size: 16px;
            line-height: 18px;
          }
        }
      }
    }

    .my-list-item:last-child {
      padding-bottom: 0;
    }
  }

  .pagination {
    margin: 0 auto !important;
    padding-bottom: 20px;
  }

}
</style>
